export enum DataLayerClassName {
    connection = 'js-tc-connection',
    connectionBanner = 'js-tc-connection-banner',
    categoryNavigation = 'js-tc-category-navigation',
    nestedCategoryNavigation = 'js-tc-nested-category-navigation',
    beautyTips = 'js-tc-beauty-tips',
    beautyTipsAnimation = 'js-tc-beauty-tips-animation',
    banner = 'js-tc-banner',
    productTile = 'js-tc-product-title',
    burgerMenuItem = 'js-tc-burger-menu-item',
    targetedCarousel = 'js-tc-targeted-carousel',
    fastAccess = 'js-tc-fast-access',
    brandorama = 'js-tc-brandorama',
    persistentBanner = 'js-tc-persistent-banner',
}
